export const environment = {
  production: false,
  serverIP: 'https://akblbatch-devapi.lfdanalytics.com/',
};
